import Cookies from "js-cookie";
import { BACKEND_URL, getHeaders, handleResponse } from "./utils";
import { ILangModelCreated, ILangModelDeleted } from "../types/lang";

export async function getLanguages() {
  try {
    const response = await fetch(`${BACKEND_URL}/languages`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get languages:", error);
    throw error;
  }
}

export async function addLanguage(lang: ILangModelCreated) {
  try {
    const response = await fetch(`${BACKEND_URL}/languages`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(lang),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get lang:", error);
    throw error;
  }
}

export async function deleteLanguage(id: ILangModelDeleted) {
  try {
    const response = await fetch(`${BACKEND_URL}/languages`, {
      method: "DELETE",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(id),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error delete lang:", error);
    throw error;
  }
}

export async function getDeletedLanguage() {
  try {
    const response = await fetch(`${BACKEND_URL}/languages/deleted`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get language:", error);
    throw error;
  }
}
export async function getRestoreLanguage(language: { languageId: number }) {
  try {
    const response = await fetch(`${BACKEND_URL}/languages/restore`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(language),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get language:", error);
    throw error;
  }
}
